import React from "react";

function Intro() {
  return (
    <section className="page-banner">
      <div className="container">
        <div className="page-content-wrapper">
          <div className="page-badge">DATA MANAGEMENT</div>
          <h1 className="page-title">
            {/* Effortlessly Collect and Track ESG Data */}
            ESG Data Management Platform
          </h1>
          <p className="page-description">
            Track, analyze, and consolidate your ESG data using a centralized
            data collection and <br /> management system for better
            decision-driven analytics and value creation.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
